const viewAsCompanyRoles = ['clientimpersonator'];
export default viewAsCompanyRoles;
